<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :hide-details="hideDetails"
        v-on:change="clear"
        :clearable="clearable"
        :dark="dark"
        :solo="solo"
        :outlined="outlined"
        :dense="dense"
        v-model="dateFormatted"
        :label="label"
        :hint="hint"
        persistent-hint
        :prepend-icon="noIcon ? '' : 'mdi-calendar'"
        v-bind="attrs"
        @blur="date = parseDate(dateFormatted)"
        v-on="on"
        autocomplete="off"
        v-mask="'##/##/####'"
        :style="inputStyle"
      ></v-text-field>
    </template>

    <v-date-picker
      v-model="date"
      :min="min"
      :max="max"
      :disabled="disabled"
      no-title
      @input="menu = false"
      @change="$emit('change', $event)"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    hideDetails: Boolean,
    clearable: Boolean,
    dark: Boolean,
    solo: Boolean,
    noIcon: Boolean,
    outlined: Boolean,
    dense: Boolean,
    hint: String,
    label: String,
    min: String,
    max: String,
    value: String,
    inputStyle: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    date: '',
    dateFormatted:'',
    menu: false,
  }),
  mounted() {
    if (this.value) this.date = this.value
  },
  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
    min: function (dateMin) {
      if (this.date < dateMin) {
        this.date = ''
      }
    },
    value: function(value) {
      this.date = value
    }
  },
  methods: {
    clear(e) {
      this.date = ''
      this.$emit('change', e)
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  }
}
</script>

<style scoped>

</style>